const causeList = [
  { id: 1, value: 'ATC error / violation' },
  { id: 2, value: 'Pilot error / violation' },
  { id: 3, value: 'Technical' },
  { id: 4, value: 'Weather' },
  { id: 5, value: 'Servicing' },
  { id: 6, value: 'Aircraft on the RWY' },
  { id: 7, value: 'Clouds' },
  { id: 8, value: 'Procedures' },
  { id: 9, value: 'Fuel' },
  { id: 10, value: 'Cause at Destination' },
  { id: 11, value: 'Others' },
  { id: 12, value: 'Equipment Failure' },
  { id: 13, value: 'RWY & TWY Lights US' },
  { id: 14, value: 'FOD on RWY' },
  { id: 15, value: 'Other Aircraft' },
  { id: 16, value: 'Obstacle' },
  { id: 17, value: 'Component Failure' },
  { id: 18, value: 'TCAS Alert' },
  { id: 19, value: 'Loss of Separation' },
  { id: 20, value: 'Vehicle on RWY' },
  { id: 21, value: 'Jet Blast' },
  { id: 22, value: 'Animals (not birds)' },
  { id: 23, value: 'Interference' },
  { id: 24, value: 'Unstable Approach' },
  { id: 25, value: 'Bird Strike' },
];

export default causeList;
